import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeInterval',
})
export class TimeIntervalPipe implements PipeTransform {
  transform(data: string): string {
    if (data) {
      const split = data.split(/\T+/g);
      const date = this.setDateDuration(split[0].replace('P', ''));
      const time = split[1]
        ? `${split[0].length > 1 ? ' - ' : ''}${this.setTimeDuration(split[1])}`
        : '';
      return date + time;
    }
    return '';
  }

  private setDateDuration(date: string): string {
    date = date.replace('Y', ' year');
    date = date.replace('M', ' month');
    date = date.replace('D', ' day');
    date = date.replace('W', ' week');
    const split = date.match(/[a-zA-Z]+|[0-9]+/g);
    let dateString = '';
    split?.map((value, i) => {
      if (!isNaN(Number(value))) {
        dateString += `${value} ${split[i + 1]}${Number(value) > 1 ? 's' : ''}${
          split[i + 2] ? ' ' : ''
        }`;
      }
    });
    return dateString;
  }

  private setTimeDuration(time: string): string {
    time = time.replace('H', ' h');
    time = time.replace('M', ' min');
    time = time.replace('S', ' s');
    const split = time.match(/[a-zA-Z]+|[0-9]+/g);
    let timeString = '';
    split?.map((value, i) => {
      if (!isNaN(Number(value))) {
        timeString += `${value} ${split[i + 1]}.${split[i + 2] ? ' ' : ''}`;
      }
    });
    return timeString;
  }
}
